import React, { useState, useEffect } from "react"
import clsx from "clsx"
import {
	Grid
} from "@material-ui/core"

import {
	VolumeUp as VolumeUpIcon,
	RateReview as RateReviewIcon,
	Create as CreateIcon
} from "@material-ui/icons"

import {
	Divider,
	AccessibleDrawer,
	SettingsMenuItem
} from "@/components"

import useChatStyles from "@/pages/Attendance/Chat/styles"
import useSidebarDrawerStyles from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/styles"
import useDidMount from "@/hooks/useDidMount"

import HeaderDrawer from "@/pages/Attendance/Chat/HeaderDrawer"

import UserNotificationSettings from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/UserSettings/UserNotificationSettings"
import SignatureSettings from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/UserSettings/SignatureSettings"
import ConversationSettings from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/UserSettings/ConversationSettings"
import { useGlobalStateStore } from "@/store/GlobalState"
import { isSmallScreen } from "@/utils/checkDevice"

type UserSettingsProps = {
	openDrawer: boolean
	onClose: () => void
	isCollapsed: boolean
}

const UserSettings = (props: UserSettingsProps) => {
	const { openDrawer, onClose, isCollapsed } = props

	const chatClasses = useChatStyles()
	const sidebarDrawerClasses = useSidebarDrawerStyles({ isCollapsed })

	const [userNotificationSettingsOpen, setUserNotificationSettingsOpen] = useState<boolean>(false)
	const [userSignatureSettingsOpen, setUserSignatureSettingsOpen] = useState<boolean>(false)
	const [userConversationSettingsOpen, setUserConversationSettingsOpen] = useState<boolean>(false)

	const globalStateStore = useGlobalStateStore()
	const isWabaChannel = globalStateStore.currentChannel?.channelType === "waba"

	const handleCloseDrawer = () => {
		// eslint-disable-next-line
        turnOnEventListenerKeydown(false)
		onClose()
	}

	const eventKeyDownHandler = (event: KeyboardEvent) => {
		const { key } = event

		if (key === "Escape") {
			handleCloseDrawer()
		}
	}

	const turnOnEventListenerKeydown = (turnOn: boolean) => {
		if (turnOn) {
			window.addEventListener(
				"keydown",
				eventKeyDownHandler,
				{ capture: true }
			)
		} else {
			window.removeEventListener(
				"keydown",
				eventKeyDownHandler,
				{ capture: true }
			)
		}
	}

	const defaultSettingOpen = () => {
		turnOnEventListenerKeydown(false)
	}

	const defaultSettingClose = () => {
		turnOnEventListenerKeydown(true)
	}

	const handleUserNotificationSettingsOpen = () => {
		setUserNotificationSettingsOpen(true)
		defaultSettingOpen()
	}

	const handleNotificationSettingsClose = () => {
		setUserNotificationSettingsOpen(false)
		defaultSettingClose()
	}

	const handleUserSignatureSettingsOpen = () => {
		setUserSignatureSettingsOpen(true)
		defaultSettingOpen()
	}

	const handleUserConversationSettingsOpen = () => {
		setUserConversationSettingsOpen(true)
		defaultSettingOpen()
	}

	const handleUserConversationSettingsClose = () => {
		setUserConversationSettingsOpen(false)
		defaultSettingOpen()
	}

	const handleUserSignatureSettingsClose = () => {
		setUserSignatureSettingsOpen(false)
		defaultSettingClose()
	}

	useDidMount(() => {
		turnOnEventListenerKeydown(true)
	})

	useEffect(() => {
		turnOnEventListenerKeydown(false)
	})

	return (
		<>
			<AccessibleDrawer
				id="new-chat-drawer"
				anchor="left"
				open={openDrawer}
				variant="persistent"
				onClose={handleCloseDrawer}
				onMobileBackButtonPress={handleCloseDrawer}
				classes={{
					paper: clsx(chatClasses.drawerPaper, !isSmallScreen && sidebarDrawerClasses.drawerPaperOffset)
				}}
			>
				<Grid container>
					<Grid item xs={12}>
						<HeaderDrawer
							title="Configurações"
							onClose={handleCloseDrawer}
						/>
					</Grid>

					<Divider size={2} orientation="horizontal" />

					<Grid item xs={12}>

						<SettingsMenuItem
							key="notifications-settings"
							icon={<VolumeUpIcon />}
							text={"Notificações"}
							onClick={handleUserNotificationSettingsOpen}
						/>

						<SettingsMenuItem
							key="chat-settings"
							icon={<RateReviewIcon />}
							text={"Assinatura"}
							onClick={handleUserSignatureSettingsOpen}
						/>

						{!isWabaChannel && <SettingsMenuItem
							key="conversation-settings"
							icon={<CreateIcon />}
							text={"Conversa"}
							onClick={handleUserConversationSettingsOpen}
						/>}
					</Grid>

				</Grid>
			</AccessibleDrawer>
			<UserNotificationSettings
				openDrawer={userNotificationSettingsOpen}
				onClose={handleNotificationSettingsClose}
				isCollapsed={isCollapsed}
			/>
			<SignatureSettings
				openDrawer={userSignatureSettingsOpen}
				onClose={handleUserSignatureSettingsClose}
				isCollapsed={isCollapsed}
			/>
			{!isWabaChannel && <ConversationSettings
				openDrawer={userConversationSettingsOpen}
				onClose={handleUserConversationSettingsClose}
				isCollapsed={isCollapsed}
			/>}
		</>
	)
}

export default UserSettings
